// 上限管理/様式第二のバリデーション用vuex
const claimState = () => ({
  data: {
    upperLimit: {
      ub: [],
    },
    details: {
      details:[]
    }
  }
})

export default {
  namespaced: true,
  state: claimState(),
  mutations: {
    valueErrSet(state:any, value:any) {
      state.data = value
    },
    valueTargeErrSet(state:any, value:any) {
      state.data[value.key] = value.value
    },
    valueTargeArrayErrSet(state:any, value:any) {
      state.data[value.key][value.idx] = value.item

      const tmpArray = JSON.parse(JSON.stringify(state.data[value.key]))

      state.data[value.key].splice(-state.data[value.key].length)

      state.data[value.key].push(...tmpArray)
    },
  },
}
